import React from 'react';
import { Redirect } from 'react-router-dom';
import { Container, Dimmer, Form, Loader } from 'semantic-ui-react';
import { ImageModel } from '../../../entities/image.model';
import AreaFields, { AreaSelection } from '../../../components/address/area-fields.component';
import MyForm from './form';
import MyFormState from './MyFormState';
import './entity-form.scss';

interface FormProps {
    match: any,
    history: any
}

interface CompanyFormState extends MyFormState {
    allCompanies: any[];
}

class CompanyForm extends MyForm<FormProps, CompanyFormState> {
    entity = 'client_company'

    constructor(props: any) {
        super(props);
        this.state = {
            model: {
                active: false,
                approved: false,
                clubMember: false,
                canPayLater: false,
                parentCompanyId: 0,
            },
            successMsg: "",
            errorMsg: "",
            loading: true,
            editing: false,
            editingSlug: false,
            slugValid: true,
            imageObj: ImageModel.empty(),
            imageObjs: { lg: ImageModel.empty(), sm: ImageModel.empty(), xs: ImageModel.empty(),
                image1: ImageModel.empty(), image2: ImageModel.empty(), image3: ImageModel.empty(),
                image4: ImageModel.empty(), image5: ImageModel.empty(), image6: ImageModel.empty()
            },
            redirect: "",
            allCompanies: [],
        }

        this.onClubMemberChange = this.onClubMemberChange.bind(this)
        this.onCanPayLaterChange = this.onCanPayLaterChange.bind(this)
    }

    componentDidMount() {
        super.componentDidMount();
        this.loadParentCompanies();
    }

    onAreaChange = (area: AreaSelection) => {
        this.setState({ model: { ...this.state.model, deliveryAreaId: area.areaId, town: area.town, district: area.district, unit: area.unit } });
    }

    loadParentCompanies() {
        const token = this.getAdminToken();
        fetch(`${process.env.REACT_APP_API_URL}list/client_company`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        })
        .then(res => {
            if (res.status === 401) {
                this.setState({ redirect: this.loginUrl });
                return;
            }
            return res.json();
        })
        .then((res: any) => {
            if (res?.data) {
                this.setState({ allCompanies: res.data });
            }
        })
        .catch(err => console.error(err));
    }

    getParentSelectOptions() {
        const editingId = this.state.model?.id;
        const options: { key: number; value: number; text: string }[] = [
            { key: 0, value: 0, text: 'Эцэг байгууллага байхгүй' }
        ];
        for (const row of this.state.allCompanies || []) {
            if (editingId && row.id === editingId) {
                continue;
            }
            options.push({ key: row.id, value: row.id, text: row.name || `ID ${row.id}` });
        }
        return options;
    }

    onParentCompanyChange = (_: any, data: any) => {
        const model: any = { ...this.state.model, parentCompanyId: data.value };
        this.setState({ model });
    }

    normalizeParentId(v: any): number {
        if (v === null || v === undefined || v === '') {
            return 0;
        }
        const n = Number(v);
        return Number.isNaN(n) ? 0 : n;
    }

    onClubMemberChange(e?: any) {
        let model: any = this.state.model;
        model.clubMember = Boolean(e.target.checked);
        this.setState({ model: model });
    }

    onCanPayLaterChange(e?: any) {
        let model: any = this.state.model;
        model.canPayLater = Boolean(e.target.checked);
        this.setState({ model: model });
    }

    validate(): boolean {
        this.setState({ successMsg: "" });
        if (!this.state.model.name) {
            this.setState({ errorMsg: "Байгууллагын нэрийг оруулна уу." });
            return false;
        }
        if (!this.state.model.register) {
            this.setState({ errorMsg: "Байгууллагын регистр оруулна уу." });
            return false;
        }
        if (!this.state.model.town) {
            this.setState({ errorMsg: "Хот сонгоно уу" });
            return false;
        }
        if (!this.state.model.district) {
            this.setState({ errorMsg: "Дүүрэг сонгоно уу" });
            return false;
        }
        // the khoroo has to be picked from the list: a saved free-text address has no id and must be picked again
        if (!this.state.model.deliveryAreaId) {
            this.setState({ errorMsg: "Хороо сонгоно уу" });
            return false;
        }
        if (!this.state.model.street) {
            this.setState({ errorMsg: "Дэлгэрэнгүй хаяг оруулна уу" });
            return false;
        }
        // if (this.state.model.id !== undefined) {
        //     if (this.state.model.active === this.originalModel.active 
        //         && this.state.model.approved === this.originalModel.approved
        //         && this.state.model.clubMember === this.originalModel.clubMember
        //         ) {
        //             this.setState({ errorMsg: "Өөрчлөлт байхгүй байна"});
        //             return false;
        //         }
        // }
        if (this.normalizeParentId(this.state.model.parentCompanyId) === Number(this.state.model.id)) {
            this.setState({ errorMsg: "Эцэг байгууллага өөрийгөө сонгох боломжгүй." });
            return false;
        }
        if (this.state.model.id !== undefined) {
            if (this.state.model.name === this.originalModel.name
                && this.state.model.register === this.originalModel.register
                && this.state.model.phone === this.originalModel.phone
                && this.state.model.approved === this.originalModel.approved
                && this.state.model.active === this.originalModel.active
                && this.state.model.clubMember === this.originalModel.clubMember
                && this.state.model.canPayLater === this.originalModel.canPayLater
                && this.state.model.town === this.originalModel.town
                && this.state.model.district === this.originalModel.district
                && this.state.model.unit === this.originalModel.unit
                && this.state.model.deliveryAreaId === this.originalModel.deliveryAreaId
                && this.state.model.street === this.originalModel.street
                && this.normalizeParentId(this.state.model.parentCompanyId) === this.normalizeParentId(this.originalModel.parentCompanyId)
                ) {
                this.setState({ errorMsg: "Өөрчлөлт байхгүй байна" });
                return false;
            }
        }
        this.setState({ errorMsg: "" });
        return true;
    }

    async save() {
        if (!this.validate()) {
            window.scrollTo(0, 0);
            return;
        }

        var token = this.getAdminToken()
        this.setState({ loading: true });

        // POST to API
        let payload = {
            companyId: this.state.model.id,
            name: this.state.model.name,
            register: this.state.model.register,
            phone: this.state.model.phone,
            active: this.state.model.active ? 1 : 0,
            approved: this.state.model.approved ? 1 : 0,
            clubMember: this.state.model.clubMember ? 1 : 0,
            canPayLater: this.state.model.canPayLater ? 1 : 0,
            // saved by the picked khoroo's id; the backend fills in the town / district / unit text
            deliveryAreaId: this.state.model.deliveryAreaId,
            street: this.state.model.street,
            parentCompanyId: this.normalizeParentId(this.state.model.parentCompanyId),
        }

        fetch(process.env.REACT_APP_API_URL + 'mongol/company', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        .then(res => {
            if (res.status === 200) {
                this.originalModel.active = this.state.model.active;
                this.originalModel.approved = this.state.model.approved;
                this.originalModel.clubMember = this.state.model.clubMember;
                this.originalModel.canPayLater = this.state.model.canPayLater;
                // the address is now the picked khoroo, so the "old address" hint goes away
                this.originalModel.deliveryAreaId = this.state.model.deliveryAreaId;
                this.originalModel.town = this.state.model.town;
                this.originalModel.district = this.state.model.district;
                this.originalModel.unit = this.state.model.unit;
                if (this.state.model.id !== undefined) {
                    this.setState({ loading: false, successMsg: "Амжилттай хадгаллаа." })
                    window.scrollTo(0,0);
                } else {
                    window.location.pathname = `/mongol/companies`
                }
            }
            else if (res.status === 401) {
                this.setState({ redirect: this.loginUrl})
            }
            else {
                res.json().then(res => {
                    if (res.error) {
                        this.setState({ loading: false, errorMsg: res.error })
                        this.recordSaved = false;
                        window.scrollTo(0,0);
                        return;
                    }
                    
                })
            }
        })
        .catch(err => {
            this.setState({ loading: false });
            console.error(err);
        });
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect}/>
        }
        return (
            <Container className="admin-entity-form">
                <Dimmer active={this.state.loading} inverted>
                    <Loader size='medium'></Loader>
                </Dimmer>
                <h2>{!this.state.editing ? 'Шинэ' : ''} Байгууллага</h2>
                <Form widths='equal' stackable>
                    <Form.Group>
                        { this.state.successMsg ? <div className="success-msg">{this.state.successMsg}</div> : null }
                        { this.state.errorMsg ? <div className="error-msg">{this.state.errorMsg}</div> : null }
                    </Form.Group>
                    <Form.Group widths='equal' className="admin-entity-form__field-row">
                        <Form.Field data-testid="company-name-input" label='Байгууллагын нэр' required control='input' value={this.state.model.name} onChange={this.onNameChange} />
                    </Form.Group>
                    <Form.Group widths='equal' className="admin-entity-form__field-row">
                        <Form.Field data-testid="company-register-input" label='Байгууллагын регистр' required control='input' value={this.state.model.register} onChange={this.onRegisterChange} />
                    </Form.Group>
                    <Form.Group widths='equal' className="admin-entity-form__field-row">
                        <Form.Field data-testid="company-phone-input" label='Утасны дугаар' required control='input' value={this.state.model.phone} onChange={this.onPhoneChange} />
                    </Form.Group>
                    <Form.Group widths='equal' className="admin-entity-form__field-row">
                        <Form.Select
                            label='Эцэг байгууллага'
                            placeholder='Сонгох'
                            options={this.getParentSelectOptions()}
                            value={this.normalizeParentId(this.state.model.parentCompanyId)}
                            onChange={this.onParentCompanyChange}
                            search
                            selection
                        />
                    </Form.Group>
                    <Form.Group className="admin-entity-form__checkbox-row">
                        <input type="checkbox" id="company-active" onChange={this.onActiveChange} checked={this.state.model.active} />
                        &nbsp;
                        <label htmlFor="company-active">{ this.state.model.active ? "Идэвхитэй" : "Идэвхигүй" }</label>
                    </Form.Group>

                    <div className="admin-entity-form__hint" style={{'height': '35px'}}>
                        <strong>Байгууллагын бүртгэлийг шалгаж баталгаажуулсан эсэх:</strong>
                    </div>
                    <Form.Group className="admin-entity-form__checkbox-row">
                        <input type="checkbox" id="company-approved" onChange={this.onApprovedChange} checked={this.state.model.approved} />
                        &nbsp;
                        <label htmlFor="company-approved">{ this.state.model.approved ? "Шалгасан" : "Шалгаагүй" }</label>
                    </Form.Group>
                    <Form.Group className="admin-entity-form__checkbox-row">
                        <input type="checkbox" id="company-club-member" data-testid="company-club-member-checkbox" onChange={this.onClubMemberChange} checked={this.state.model.clubMember} />
                        &nbsp;
                        <label htmlFor="company-club-member">{"Клуб гишүүн" + (this.state.model.clubMember ? " (тийм)" : " (үгүй)")}</label>
                    </Form.Group>
                    <Form.Group className="admin-entity-form__checkbox-row">
                        <input type="checkbox" id="company-pay-later" data-testid="company-pay-later-checkbox" onChange={this.onCanPayLaterChange} checked={this.state.model.canPayLater} />
                        &nbsp;
                        <label htmlFor="company-pay-later">{"Paylater" + (this.state.model.canPayLater ? " (тийм)" : " (үгүй)")}</label>
                    </Form.Group>
                    <Form.Group className="admin-entity-form__field-row">
                        <div className="admin-entity-form__label">Хаяг:</div>
                    </Form.Group>
                    <Form.Group className="admin-entity-form__field-row">
                        <AreaFields
                            testIdPrefix="company"
                            areaId={this.state.model.deliveryAreaId}
                            town={this.state.model.town || ''}
                            district={this.state.model.district || ''}
                            onChange={this.onAreaChange}
                            legacy={this.state.editing && this.originalModel && !this.originalModel.deliveryAreaId
                                ? { town: this.originalModel.town || '', district: this.originalModel.district || '', unit: this.originalModel.unit || '' }
                                : null}
                        />
                    </Form.Group>
                    <Form.Group className="admin-entity-form__field-row">
                        <Form.TextArea data-testid="company-street-input" label='Дэлгэрэнгүй хаяг' required value={this.state.model.street} onChange={this.onStreetChange} />
                    </Form.Group>
                    {/* <Form.Group>
                        <MyLabel>Зипкод</MyLabel>
                        <div>{this.state.model.zipcode}</div>
                    </Form.Group> */}

                    <br/>
                    <Form.Button data-testid="company-save-button" disabled={this.state.loading} onClick={() => this.save()}>Хадгалах</Form.Button>
                </Form>
            </Container>
        );
    }
}

export default CompanyForm;